import charts from './home/charts.png';

export class Screens {
  home = {
    charts,
  };
}
